'use client'

import { Phone, MessageCircle } from 'lucide-react'
import { useLanguage } from '@/contexts/LanguageContext'

export default function FloatingContactButtons() {
  const { language } = useLanguage()

  const phoneNumber = '+447879643396' // Replace with your actual phone number
  const whatsappNumber = '+447879643396' // Replace with your actual WhatsApp number
  const whatsappMessage = language === 'en' 
    ? 'Hi! I\'m interested in your garden maintenance services. Could you please provide a quote?'
    : 'Helo! Mae gen i ddiddordeb yn eich gwasanaethau cynnal a chadw gardd. A allwch chi roi dyfynbris os gwelwch yn dda?'

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`
  }

  const handleWhatsApp = () => {
    const encodedMessage = encodeURIComponent(whatsappMessage)
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank')
  }

  return (
    <>
      {/* Mobile and Tablet Only - Floating Contact Buttons */}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-3 lg:hidden">
        {/* Call Button */}
        <button
          onClick={handleCall}
          className="flex items-center justify-center w-14 h-14 bg-emerald-700 hover:bg-emerald-800 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110"
          aria-label={language === 'en' ? 'Call Now' : 'Ffoniwch Nawr'}
        >
          <Phone className="w-6 h-6" />
        </button>

        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsApp}
          className="flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110"
          aria-label={language === 'en' ? 'WhatsApp Us' : 'WhatsApp Ni'}
        >
          <MessageCircle className="w-6 h-6" />
        </button>
      </div>
    </>
  )
} 